import { connect } from 'react-redux';

import { resetGroupAndCategory, fetchDeps, fetchGroups, fetchDepCategories, fetchGroupCategories, fetchProductsByGroup, fetchProductsByCategory, fetchProductsByCategorySunset, fetchProducts, selectProduct, resetCurrentProduct, setGroupCategory, attachDocument, fetchQuickAccess,
  importProducts, } from '../../actions/products_actions';
import { setOriginPage } from '../../actions/inventories_actions';

import Products from '../../components/Products/products';

function mapStateToProps(state) {
  return {
    groups: state.products.groups,
    deps: state.products.deps,
    products: state.products.all,
    currentProduct: state.products.currentProduct,
    isLoading: state.products.isLoading,
    gfdLoading: state.products.gfdLoading,
    error: state.products.error,
    groupCategories: state.products.groupCategories,
    groupCategoryError: state.products.groupCategoryError,
    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
    currentCategoryGroup: state.products.currentCategoryGroup,
    userType: state.auth.userType,
    userPermissions: state.auth.userPermissions,
    product: state.products.product,
    selectedWarehouse: state.header.selectedWarehouse,
    selectedCompany: state.header.selectedCompany,
    productTotalPages: state.products.productTotalPages
  };
}

export default connect(mapStateToProps, { setOriginPage, resetGroupAndCategory, fetchDeps, fetchGroups, fetchDepCategories, fetchGroupCategories, fetchProductsByGroup, fetchProductsByCategory, fetchProductsByCategorySunset, fetchProducts, selectProduct, resetCurrentProduct, setGroupCategory, attachDocument, fetchQuickAccess, importProducts })(Products);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/products.jsx